import {
  isPlaybookSectionNode,
  type PlaybookNode,
} from "@repo/app-types/entities/playbook";

/**
 * User prompt sent by Review feedback's Suggest edits action. The playbook-node
 * tag reaches the model, while the structured-content renderer drops its
 * unknown wrapper and preserves its readable text.
 */
export function buildFeedbackSuggestionUserPrompt(node: PlaybookNode): string {
  const nodeKind = isPlaybookSectionNode(node) ? "section" : "criteria";
  const playbookNode = `<playbookNode nodeId='${node.id}' nodeType='${nodeKind}'>“${node.name}” ${nodeKind}</playbookNode>`;

  return `Get all open feedback for the ${playbookNode}. Use the feedback as evidence to determine how to optimize the ${nodeKind}. Draft the smallest coherent changes that address patterns across the feedback without overfitting to any individual call or feedback, then validate the proposed changes and create AI suggestions.`;
}
